export default __webpack_public_path__ + "b09b5f56fed59994410c8e017fe5aaab.jpg";